import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LaunchDarklyFeatureKey } from '../../../shared/launch-darkly-feature-key';
import { LaunchDarklyService } from 'src/app/services/launch-darkly-service/launch-darkly-service';

@Injectable({
    providedIn: 'root',
})
export class CanActivateGiftCardBalanceGuard implements CanActivate {
    constructor(
        private launchDarklyService: LaunchDarklyService,
        private router: Router
    ) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const hasGiftCardBalanceEnabled = this.launchDarklyService.isFeatureActive(
            LaunchDarklyFeatureKey.GiftCardBalance
        );

        if (!hasGiftCardBalanceEnabled) {
            return this.router.parseUrl('/not_found');
        }

        return true;
    }
}
